var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('van-nav-bar',{staticClass:"top-h",attrs:{"fixed":"","title":"企业自荐","left-arrow":""},on:{"click-left":_vm.back}}),_c('div',{staticClass:"content-wrapper mb-4",staticStyle:{"background-color":"#f7f8fa"}},[_c('div',{staticClass:"invert-wrapper"},[_c('ClueEntry',{attrs:{"iscomponent":true}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }